import React, {useState, useEffect, useRef } from 'react';
import { Container, Modal, Row, Col } from 'react-bootstrap';
import './css/Login.css';
//import Header from './header';
import axios from 'axios';
import  { Redirect } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker';
//import Loader from 'react-loader-spinner';
import { DataGrid } from '@mui/x-data-grid';
import Button  from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';

const Areas = () =>{

    // ---------------------------------------- [ hooks ] ----------------------------------------

    const [areasListado, setAreasListado]           = useState([]);
    const [visible , SetVisible]                    = useState({ show: false, id: null });
    const [visible2 , SetVisible2]                  = useState(false);
    const [visible3 , SetVisible3]                  = useState(false);
    const [nombreArea, setNombreArea]               = useState("");
    const [status, setStatus]                       = useState("");
    const [errorNombreArea, setErrorNombreArea]     = useState(null);
    const [errorStatus, setErrorStatus]             = useState(null);
    const [showBtn, setShowBtn]                     = useState(false);
    const [dataArea, setDataArea]                   = useState([]);
    const [isAuthorized, setIsAuthorized]           = useState(true);

    //-------------------- nuevo data grid -------------------
    const [loading, setLoading]                     = useState(false);
    const [page, setPage]                           = useState(0);
    const [selectionModel, setSelectionModel]       = useState([]);
    const prevSelectionModel                        = useRef(selectionModel);
    const [totalRows, setTotalRows]                 = useState(0);
    //---- snackbar
    const [open, setOpen]                           = useState(false);
    
    let ud       = sessionStorage.getItem('userData');
    let userData = JSON.parse(ud);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }
        setOpen(false);
    };
    
    const OnChangeNombreArea = (e) =>{
        setNombreArea(e.target.value);        
    }

    const OnChangeStatus = (e) =>{
        setStatus(e.target.value);          
    }

    const updateData = () => {

        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
            baseURL: global.config.server_endpoint.url,
            timeout: 10000,
            headers: {'Authorization': 'Bearer '+userData.token}
        });

        trackPromise(

            instance.get('/areas')
            .then(response => {
                setIsAuthorized(true);
                setAreasListado(response.data.data.data);
            })
            .catch(e => {
                setIsAuthorized(false);
                console.log("Expired token - Error #45435");
            })

        );
        
    }

    useEffect(() => {

        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        if(userData.jerarquia<3){
            const instance = axios.create({
                baseURL: global.config.server_endpoint.url,
                timeout: 10000,
                headers: {'Authorization': 'Bearer '+userData.token}
            });
            
        const retrieveData = () => {

            trackPromise(

                instance.get('/areas')
                .then(response => {
                    
                    setTotalRows(response.data.data.total);
                    setAreasListado(response.data.data.data);

                })
                .catch(e => {
                    setIsAuthorized(false);
                    console.log("Expired token - Error #45435");
                })
  
            );
            
        }

        retrieveData();

        }
        

    },[]);

    const updateAreas = () => {
        setAreasListado([]);
        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
            baseURL: global.config.server_endpoint.url,
            timeout: 10000,
            headers: {'Authorization': 'Bearer '+userData.token}
        });

        trackPromise(

            instance.get('/areas')
            .then(response => {
                setAreasListado(response.data.data.data);
            })
            .catch(e => {
              console.log(e);
            })

        );
    }

    const NextPage = (page) => {

        setLoading(true);
        setAreasListado([]);
        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
            baseURL: global.config.server_endpoint.url,
            timeout: 10000,
            headers: {'Authorization': 'Bearer '+userData.token}
        });

        trackPromise(

            instance.get('/areas?page='+page)
            .then(response => {
                setAreasListado(response.data.data.data);
                setTotalRows(response.data.data.total);
                setLoading(false);
            })
            .catch(e => {
              console.log(e);
            })

        );
    }

    const handleDeleteTrue = (id) => { 

        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
            baseURL: global.config.server_endpoint.url,
            timeout: 10000,
            headers: {'Authorization': 'Bearer '+userData.token}
        });

        trackPromise(
            instance.delete('/areas/'+id)
            .then(response => {
                if(response.status === 200){
                    updateAreas();
                    NextPage(page);
                    SetVisible({
                        visible: false,
                        id: null,
                    })
                }
            })
            .catch(e => {
                console.log(e);
            })
        );
    }

    const handleDeleteFalse = () => {
        SetVisible(false);
    }

    const handleDeleteFalse2 = () => {
        SetVisible2(false);
    }

    const handleDeleteFalse3 = () => {
        SetVisible3(false);
    }

    const openModal = (id) => {
        SetVisible2(true);
        setNombreArea(""); 
        setStatus("");
        setShowBtn(false); 

        let ud       = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
            baseURL: global.config.server_endpoint.url,
            timeout: 10000,
            headers: {'Authorization': 'Bearer '+userData.token}
        });

        trackPromise(
            instance.get('areas/'+id)
            .then(response => {
                setDataArea(response.data.data);
                setNombreArea(response.data.data.nombre_area);
                setStatus(response.data.data.status);
            })
              .catch(e => {
                console.log(e);
              })
          );
    }

    const openModalNew = (id) => {
        SetVisible3(true);
        setShowBtn(false)
        setNombreArea(""); 
        setStatus("");

    }

    const handleSubmit = () => {

        let errorsForm = 0;
        setShowBtn(true)
            const regex_letras 	= /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$/u;
            
            //---------------------- [		validaciones		] --------------------------
            if(nombreArea.match(regex_letras) == null){
                //console.log("Error: solo letras");
                setErrorNombreArea("Sólo letras");
                errorsForm = errorsForm + 1;
                console.log(errorsForm);
            }
            else{
                setErrorNombreArea("");
            }

                if(!status){
                    //console.log("Error: solo letras");
                    setErrorStatus("Por favor seleccione una opción válida");
                    errorsForm = errorsForm + 1;
                    console.log(errorsForm);
                }
                else{
                    setErrorStatus("");
                }

                if(!errorsForm){

                    let ud       = sessionStorage.getItem('userData');
                    let userData = JSON.parse(ud);

                    const instance = axios.create({
                        baseURL: global.config.server_endpoint.url,
                        timeout: 10000,
                        headers: {'Authorization': 'Bearer '+userData.token}
                    });

                    trackPromise(
                        instance.put('areas/'+dataArea.id, { 
                            nombre_area: nombreArea, 
                            status: status
                            })
                        .then(response => {
                          
                          if(response.data.success === true){
                                //setAreasListado([]);
                                setNombreArea(""); 
                                setStatus("");
                                SetVisible2(false);
                                updateData();
                                NextPage(page);
                                setOpen(true);
                                //console.log("Pagina: "+page);
                          }
                          
                        })
                          .catch(e => {
                            console.log(e);
                          })
                      );
                } 
    }

    const handleSubmitNew = () => {

        let errorsForm = 0;
        setShowBtn(true)
            const regex_letras 	= /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '-]+$/u;
            
            //---------------------- [		validaciones		] --------------------------
            if(nombreArea.match(regex_letras) == null){
                //console.log("Error: solo letras");
                setErrorNombreArea("Sólo letras");
                errorsForm = errorsForm + 1;
                console.log(errorsForm);
            }
            else{
                setErrorNombreArea("");
            }

                if(!status){
                    //console.log("Error: solo letras");
                    setErrorStatus("Por favor seleccione una opción válida");
                    errorsForm = errorsForm + 1;
                    console.log(errorsForm);
                }
                else{
                    setErrorStatus("");
                }

                if(!errorsForm){

                    let ud       = sessionStorage.getItem('userData');
                    let userData = JSON.parse(ud);

                    const instance = axios.create({
                        baseURL: global.config.server_endpoint.url,
                        timeout: 10000,
                        headers: {'Authorization': 'Bearer '+userData.token}
                    });

                    trackPromise(
                        instance.post('areas', { 
                            nombre_area: nombreArea, 
                            status: status
                            })
                        .then(response => {
                          
                          if(response.data.success === true){
                                //alert("El área se guardó exitosamente")
                                setAreasListado([]);
                                updateData();
                                setNombreArea(""); 
                                setStatus("");
                                SetVisible3(false);
                                NextPage(page);
                          }
                          
                        })
                          .catch(e => {
                            console.log(e);
                          })
                      );
                } 
                else{
                    setShowBtn(false)
                }
    }

    const showConfirm = (id) => {
        SetVisible({visible: true, id: id});
    }

    const columns = [
        { field: 'id', 
            headerName: 'ID', 
            headerClassName: 'letal',
            width: 90 },
        {
          field: 'nombre_area',
          headerName: 'Nombre área',
          minWidth: 250,
          flex: 1,
          headerClassName: 'letal',
        },
        {
          field: 'status',
          flex: 0.5,
          headerName: 'Estatus',
          headerClassName: 'letal',
          minWidth: 100,
          renderCell: (params) => {
                let txt_status = "";
                //console.log(params.row.status);
                switch (params.row.status) {
                    case 1:
                        txt_status = "Activo"
                        break;
                    case 2:
                            txt_status = "Inactivo"
                        break;
                    default:
                        txt_status = "-"
                        break;
                }

                return txt_status;
          },
        },
        {
            field: ' ',
            headerName: "sd",
            headerClassName: 'letal',
            width: 250,
            sortable: false,
            renderHeader: (params) => (
                <h2 style={{height: "90px"}}>&nbsp;</h2>
            ),
            renderCell: (params) => (
                <strong>
                    <Tooltip title="Borrar">
                        <Button
                            variant="text"
                            color="error"
                            size="large"
                            className="pr-1 mr-1 btn_emp"
                            startIcon={<DeleteIcon />}
                            onClick={() => showConfirm(params.id)}
                        />
                    </Tooltip>
                  
                    <Tooltip title="Editar">
                        <Button
                            variant="text"
                            color="primary"
                            size="large"
                            className="mr-1"
                            startIcon={<EditIcon />}
                            onClick={() => openModal(params.id)}
                        />
                    </Tooltip>
                </strong>
            ),
        }
        
    
    ];

    const rows = areasListado;
    
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    ///----------------------[  main return  ]---------------------------
      
     if(sessionStorage.getItem('userData') != null && userData.jerarquia<3 && isAuthorized){
        return(<>
                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        La información se guardo exitosamente.
                    </Alert>
                </Snackbar>

                <Container className="mr-inf">
                    <div className="row">
                        <div className="col-10">
                            <div className="titulo_login">Áreas</div>
                        </div>
                        <div className="col-2">
                        <IconButton aria-label="delete" className="mt-2 float-right" color="error" size="large" onClick={() => openModalNew()}>
                            <AddCircle fontSize="inherit" className="new-icon"  />
                            <h1 className="add-new ml-2 mt-2">Agregar</h1>
                        </IconButton>
                        {/* <h1 className="addEmpleado handy" onClick={() => openModalNew()}>
                                <FontAwesomeIcon icon={faPlus} className="icono_blanco" />
                            </h1> */}
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-12">
                            <div className="areas_datagrid">
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pagination
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                    paginationMode="server"
                                    rowCount={totalRows}
                                    loading={loading}
                                    onPageChange={(newPage) => {
                                        prevSelectionModel.current = selectionModel;
                                        NextPage(newPage+1);
                                        setPage(newPage+1);
                                    }}
                                    onSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                    }}
                                    selectionModel={selectionModel}
                                />
                            </div>
                        </div>
                    </div>

            </Container>

            <Modal size="lg" show={visible.visible} onHide={handleDeleteFalse} animation={false}>
                <Modal.Header closeButton className="no-line-footer">
                    <Modal.Title className="titulo_login">¿Estas seguro que deseas eliminarlo?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col className="text-center">
                            <Button onClick={() => handleDeleteTrue(visible.id)} variant="contained" color="success" className="mt-3 float-left" >
                                Confirmar
                             </Button>
                             <Button onClick={() => handleDeleteFalse()} variant="contained" color="error" className="mt-3 float-right" >
                                Cancelar
                             </Button> 
                             </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={visible2} onHide={handleDeleteFalse2} animation={false}>
                <Modal.Header closeButton className="no-line-footer">
                    <Modal.Title className="titulo_login">Editar área</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                    <div className="row mt-4">
					<div className="col-md-2">
						<span className="txt_listado">Nombre área</span>
					</div>
					<div className="col-md-10">
						<span><input type="text" className="form-control" id="inp_nombre_proyecto" name="nombre_area" defaultValue={nombreArea || ''} onChange={OnChangeNombreArea} required="required" /></span>
						<span className="red_alert">{ errorNombreArea }</span>
					</div>
				</div>

				<div className="row mt-3">
					<div className="col-md-2">
						<span className="txt_listado">Status</span>
					</div>
					<div className="col-md-10">
						<span>
							<select className="form-control" id="inp_status" name="status" value={status} onChange={OnChangeStatus} required="required">
								<option value="">Seleccione...</option>
                                <option value="1">Activo</option>
								<option value="2">Inactivo</option>
							</select>
						</span>
                        <span className="red_alert">{ errorStatus }</span>
					</div>
				</div>
                <div className="row mt-3 mb-5">
					<div className="col-md-2">
						<span>&nbsp;</span>
					</div>
					<div className="col-md-10">
						<span><Button type="submit" value="Guardar" disabled={showBtn}  variant="contained" color='success' className="w-100" id="inp_enviar" name="inp_enviar" onClick={handleSubmit}>Guardar</Button></span>
					</div>
				</div>
                    </Container>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={visible3} onHide={handleDeleteFalse3} animation={false}>
                <Modal.Header closeButton className="no-line-footer">
                    <Modal.Title className="titulo_login">Agregar área</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                    <div className="row mt-4">
					<div className="col-md-2">
                        <span className="txt_listado">Nombre área</span>
					</div>
					<div className="col-md-10">
						<span><input type="text" className="form-control" id="inp_nombre_proyecto" name="nombre_area" defaultValue={nombreArea || ''} onChange={OnChangeNombreArea} required="required" /></span>
						<span className="red_alert">{ errorNombreArea }</span>
					</div>
				</div>

				<div className="row mt-3">
					<div className="col-md-2">
                        <span className="txt_listado">Status</span>
					</div>
					<div className="col-md-10">
						<span>
							<select className="form-control" id="inp_status" name="status" value={status} onChange={OnChangeStatus} required="required">
								<option value="">Seleccione...</option>
                                <option value="1">Activo</option>
								<option value="2">Inactivo</option>
							</select>
						</span>
                        <span className="red_alert">{ errorStatus }</span>
					</div>
				</div>
                <div className="row mt-3 mb-5">
					<div className="col-md-2">
						<span>&nbsp;</span>
					</div>
					<div className="col-md-10">
						<span><Button type="submit" variant="contained" color="success" disabled={showBtn} className="btn btn-success form-control" id="inp_enviar" name="inp_enviar" onClick={handleSubmitNew}>Guardar</Button></span>
					</div>
				</div>
                    </Container>
                </Modal.Body>
            </Modal>

        </>)
     }
     else{
        return <Redirect to="/logout"  />;
    }
};

export default Areas;